<mat-card
  class="alert-wrap"
  data-test-id="alertMessageComWrap"
  [ngClass]="[checkForCriticalMessage() ? 'alert-error-bg' : 'alert-info-bg']"
  [style.background]="message[0].color"
  [style.color]="message[0].fontColor"
  [style.padding]="message[0].padding"
  [style.maxWidth]="message[0].width"
>
  <div
    class="alert-body"
    data-test-id="intxtAlertMessage"
    [ngClass]="{
      'alert-error-cls': checkForCriticalMessage(),
      'alert-info-cls': !checkForCriticalMessage(),
      'single-message': message && message.length == 1
    }"
  >
    <table>
      <tr>
        <td>
          <span
            class="alert-icon"
            [ngClass]="[
              checkForCriticalMessage() ? 'icon-white' : 'icon-black'
            ]"
          ></span>
        </td>
        <td>
          <span
            data-test-id="lblAlertMessage"
            class="alert-content business-alert-content"
            [ngClass]="[
              checkForCriticalMessage() ? 'alert-error-cls' : 'alert-info-cls'
            ]"
            [innerHtml]="generateMessage()"
          ></span>
          <a
            class="contact-us-link"
            (click)="showContactForm()"
            *ngIf="checkForContactUs()"
            >contact us.</a
          >
          <a
            class="alert-btn"
            *ngIf="message && message.length > 1 && !checkForCriticalMessage()"
            (click)="showReqAccessDialog()"
            >View Alerts</a
          >
          <button
            class="view-alert view-alert-btn"
            cignaButton="secondary small "
            (click)="showReqAccessDialog()"
            *ngIf="checkForCriticalMessage() && message && message.length > 1"
          >
            View Alerts
          </button>
          <a
            class="view-alert-mobile view-alert-btn"
            cignaButton="secondary small"
            (click)="showReqAccessDialog()"
            *ngIf="checkForCriticalMessage() && message && message.length > 1"
          >
            View
          </a>
          <a
            class="alert-btn"
            (click)="showContactForm()"
            *ngIf="checkForContactMessage()"
            >contact us.</a
          >
          <a
            class="alert-btn-mobile"
            *ngIf="message && message.length > 1 && !checkForCriticalMessage()"
            (click)="showReqAccessDialog()"
            >View</a
          >
        </td>
      </tr>
    </table>
  </div>
</mat-card>
